module.exports = __webpack_public_path__ + "8a5356e9/img/settings-ico.a214628d.svg";